/**
 * Resolves the entropy rendering place based on the URL and comet browser status.
 * @param url The URL to resolve the entropy rendering place for.
 * @param isComet Whether the browser is a comet browser.
 * @returns The entropy rendering place.
 */
export function resolveErp(url, isComet) {
    if (import.meta.env.VITE_IS_VOICE_ASSISTANT_BUILD) {
        return 'voice-assistant';
    }
    if (import.meta.env.VITE_IS_EMBEDDED_SIDECAR_BUILD) {
        return 'embedded-sidecar';
    }
    if (url?.pathname.startsWith('/sidecar')) {
        return 'sidecar';
    }
    if (url?.pathname.startsWith('/mobile-sidecar')) {
        return 'mobile-sidecar';
    }
    if (isComet) {
        return 'tab';
    }
    return undefined;
}
//# sourceMappingURL=resolveErp.js.map